import globals from "../partials/global-variables";
import { ButtonPrimary } from "../partials/buttons";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

export default {
  container: {
    textAlign: "right",
    padding: "40px 0",
    "& button": {
      ...ButtonPrimary,
      marginRight: 0,
      background: stylesConfig.colors.secondary.spectrum500,
      borderColor: stylesConfig.colors.secondary.spectrum500,
      position: "relative",
      textTransform: "uppercase",
      borderRadius: 0,
      [mediaQuery.hover]: {
        "&:hover": {
          background: stylesConfig.colors.secondary.spectrum800,
        },
      },
      "&:active": {
        background: stylesConfig.colors.secondaryAccentColorVariants.dark,
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        order: 2,
        width: "calc(50% - 5px)",
        paddingLeft: 0,
        paddingRight: 0,
        maxWidth: "215px",
      },
    },
    "& .input-wrapper": {
      border: "1px solid",
      borderColor: stylesConfig.colors.secondaryAccentColorVariants.gray,
      width: "100%",
      padding: ["5px", "10px", "5px", 0],
      backgroundColor: globals.colors.white,
      marginRight: "15px",
    },
    "& input": {
      width: "100%",
      background: "transparent",
      border: 0,
      fontSize: "14px",
      height: "37px",
      padding: "5px 8px",
      outline: 0,
    },
    "& .search-wrapper": {
      width: "60%",
      display: "flex",
      margin: "0 auto",
    },
  },
};
